export const CONTENT_SPACE_ROUTES = {
  PRIVATE: {
    COURSES: (companyId: string) => `/private/companies/${companyId}/courses`,
    COURSE: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}`,
    COURSE_UPLOAD: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/upload`,
    COURSE_DATA: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/data`,
    INITIALIZE: (companyId: string) => `/private/companies/${companyId}/courses/initialize`,
    GROUPS: (companyId: string) => `/private/companies/${companyId}/courses/groups`,
    GROUP: (companyId: string, groupId: string) =>
      `/private/companies/${companyId}/courses/groups/${groupId}`,
    // Portal routes (N:M)
    PORTALS: (companyId: string) => `/private/companies/${companyId}/courses/portals`,
    PORTAL: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/courses/portals/${portalId}`,
    PORTAL_STATUS: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/courses/portals/${portalId}/status`,
    COURSE_STATUS: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/status`,
    COURSE_PORTALS: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/portals`,
    PORTAL_COURSES_ATTACH: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/courses/portals/${portalId}/courses`,
    PER_COURSE_PORTAL: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/per-course-portal`,
    RESET: (companyId: string) => `/private/companies/${companyId}/courses/reset`,
    LRS_CONFIG: (companyId: string) => `/private/companies/${companyId}/courses/lrs-config`,
    SSO_CONFIGS: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/sso-configs`,
    SSO_CONFIG: (companyId: string, portalId: string, configId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/sso-configs/${configId}`,
    SSO_CONFIG_TEST: (companyId: string, portalId: string, configId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/sso-configs/${configId}/test`,
    SSO_CONFIG_APPLY: (companyId: string, portalId: string, configId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/sso-configs/${configId}/apply`,
    SSO_CONFIG_REGENERATE_API_KEY: (companyId: string, portalId: string, configId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/sso-configs/${configId}/regenerate-api-key`,
    // Webhook routes
    WEBHOOKS: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/webhooks`,
    WEBHOOK: (companyId: string, portalId: string, webhookId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/webhooks/${webhookId}`,
    // Custom domain routes
    PORTAL_CUSTOM_DOMAIN: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/custom-domain`,
    PORTAL_CUSTOM_DOMAIN_VERIFY: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/custom-domain/verify`,
    PORTAL_CUSTOM_DOMAIN_RECONCILE: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/custom-domain/reconcile`,
    COURSE_VERSIONS: (companyId: string, courseId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/versions`,
    COURSE_VERSION_ACTIVATE: (companyId: string, courseId: string, versionId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/versions/${versionId}/activate`,
    COURSE_VERSION_DOWNLOAD: (companyId: string, courseId: string, versionId: string) =>
      `/private/companies/${companyId}/courses/${courseId}/versions/${versionId}/download`,
    // Redirect routes
    PORTAL_REDIRECTS: (companyId: string, portalId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/redirects`,
    PORTAL_REDIRECT: (companyId: string, portalId: string, redirectId: string) =>
      `/private/companies/${companyId}/portals/${portalId}/redirects/${redirectId}`,
  },
  PUBLIC: {
    COURSES: (companyId: string) => `/public/companies/${companyId}/courses/public`,
    SECRET: (companyId: string, secret: string) =>
      `/public/companies/${companyId}/courses/secret/${secret}`,
    DISPATCH: (companyId: string) => `/public/companies/${companyId}/courses/dispatch`,
  },
  STATIC: {
    BASE: '/static',
    COURSE: (courseId: string, indexFile: string) => `/static/${courseId}/${indexFile}`,
  },
} as const
